import { Dialog, DialogContent } from '@forgeglobal/design-framework';
import useStyles from './style';
import { useState } from 'react';
import { useEsignConsentStatusMutation } from '@tcs/client-portal-common/hooks/useEsignConsentStatusMutation';
import { EsignConsentPage } from './EsignConsentPage';
import { ConfirmDenyPage } from './ConfirmDenyPage';
import { EsignConsentStatus } from '@tcs/client-portal-api/platform_generated';

export const OnlineAccessSelector = ({ accountId }) => {
  const classes = useStyles();
  const mutator = useEsignConsentStatusMutation(accountId);
  const [page, setPage] = useState<'Esign' | 'ConfirmDeny'>('Esign');
  const [hasScrolled, setHasScrolled] = useState<boolean>(false);

  const handleEsignClick = async (value: EsignConsentStatus) => {
    if (value === 'Allow') {
      await mutator.mutateAsync(value);
    } else {
      setHasScrolled(true);
      setPage('ConfirmDeny');
    }
  };

  const getPage = () => {
    switch (page) {
      case 'Esign':
        return (
          <EsignConsentPage
            handleClick={handleEsignClick}
            hasScrolled={hasScrolled}
          />
        );
      case 'ConfirmDeny':
        return (
          <ConfirmDenyPage
            cancelClick={() => setPage('Esign')}
            confirmClick={() => mutator.mutateAsync(EsignConsentStatus.DENY)}
          />
        );
    }
  };

  return (
    <Dialog open={true} disableEnforceFocus>
      <DialogContent className={classes.content}>{getPage()}</DialogContent>
    </Dialog>
  );
};
